<span class="closeModal pull-right" (click)="cancelar()"><i class="fa fa-times"></i></span>
<h1 mat-dialog-title>Concepto</h1>

<mat-dialog-content class="mat-card-content modalFecha">
  <div #mydiv></div>
  <section>
    <mat-error *ngIf="conceptoInvalido" class="conceptoInvalido">{{MensajeError}}</mat-error>
    <form class="form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <div class="row" hidden="true">
        <input formControlName="id" name="id" type="text" class="form-control" />
        <input formControlName="idIndemnizacion" name="idIndemnizacion" type="text" class="form-control" />
      </div>

      <div class="form-group">
        <label class="col-form-label font-bold">Código Nómina</label>
        <div>
          <comboTools [list]=codigosNominaList
                      selected='codigoNomina'
                      [formParent]="registerForm"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      (SelectedChange)="onChangeCodigoNomina($event)"
          ></comboTools>
          <div *ngIf="registerFormControl.codigoNomina.invalid && (registerFormControl.codigoNomina?.dirty || registerFormControl.codigoNomina?.touched || submitted)" class="text-danger">
            Código Nómina es Requerido
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class=" col-form-label font-bold">Cantidad</label>
        <input formControlName="cantidad" name ="selectedCantidad" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.cantidad.errors && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)}"/>
      </div>
      
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class=" col-form-label font-bold">Importe</label>
            <input formControlName="importe" name ="selectedImporte" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.importe.errors && (registerFormControl.importe?.dirty || registerFormControl.importe?.touched || submitted)}"/>
          </div>
          <!-- <app-input-numeric [inputNumericFormControl]="form" [ValidarRequerido]="true" placeHolderValue="Importe" [actualizarFormato]="actualizarFormatoInputNumerico"></app-input-numeric> -->
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="col-form-label font-bold">Moneda</label>
            <div>
              <comboTools [list]=monedasList
                          selected='moneda'
                          [formParent]="registerForm"
                          [isEditing]=disabledEditing
                          filter="descripcion"
                          ph="Moneda"
                          [AppendMydiv]="mydiv"></comboTools>
              <div *ngIf="registerFormControl.moneda.invalid && (registerFormControl.moneda?.dirty || registerFormControl.moneda?.touched || submitted)" class="text-danger">
                Moneda es Requerida
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button mat-button type="button" (click)="cancelar()" class="button">Cerrar</button>
        <button mat-button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </form>
  </section>
</mat-dialog-content>
